import React, { useState } from "react";
import classes from "./myteam.module.css";
import { BiSortAlt2 } from "react-icons/bi";
import {
  MenuItem,
  Menu,
  Typography,
  Card,
  Button,
  Divider,
  TextField,
} from "@mui/material";
import {
  Checkbox,
  FormControlLabel,
  Box,
  Chip,
  LinearProgress,
} from "@mui/material";
import { InputAdornment } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import { IoAddCircleOutline } from "react-icons/io5";
import { FiUpload } from "react-icons/fi";
import AddMemberModal from "./AddMemberModal";
import ImportMembersModal from "./ImportMembersModal";
import { GeofenceChip } from "./Geofence/GeofenceParts";
import { hasGeofence } from "./Geofence/geofenceApi";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  checkOnline,
  PublishMessage,
} from "../../../utilities/commonFunctions";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import {
  DELETE_MEMBER,
  TEAM_LIST,
  TEAM_MEMBER_DETAILS,
} from "../../../api-calls/api-urls";
import { getLanguagedataFunction } from "../../../utilities/language";
import {
  ArrowDownIcon,
  BrudCrumbBackIcon,
  BrudCrumbNextIcon,
  FilterIcon,
  SearchIcon,
  TotalMembersIcon,
} from "../../../components/Icons";
import {
  TeamMemberStatus,
  locationTimeFilter,
} from "../../../utilities/constants";
import { saveTeamMemberStatusFilter } from "../../../Redux/actions/team-actions";
import { saveLocationTimeFilter } from "../../../Redux/actions/location-action";
import { setHeaderName } from "../../../Redux/actions/user-actions";
import AlertBox from "../../../components/AlertBox";
// import { TextFields } from "@mui/icons-material";
import TeamMemberCard from "./teamMemberCard";

const TeamViewPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [typecall, setTypeCall] = useState();
  const [serachValue, setSearchValue] = useState("");
  const [anchorEl, setAnchorEl] = useState();
  const [openMenu, setOpenMenu] = useState();
  const [anchorEl1, setAnchorEl1] = useState();
  const [modletoggle, setModleToggle] = useState(false);
  const [importModalToggle, setImportModalToggle] = useState(false);
  const [editMember, setEditMember] = useState();
  const [currentTeam, setCurrentTeam] = useState();
  const [currentTeamMembers, setCurrentTeamMembers] = useState([]);
  const open = Boolean(anchorEl);
  const open1 = Boolean(anchorEl1);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState();
  const [selectedValues, setSelectedValues] = useState([
    "all",
    "online",
    "offline",
  ]); // State to store selected values
  const [selectedValues1, setSelectedValues1] = useState("oldest_to_newest");
  const ln = useSelector((state) => state.allUsers.language_json);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [onlineStatuses, setOnlineStatuses] = useState({});
  const { teamMembersList } = useSelector((state) => state.allUsers);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once on mount (getLanguagedataFunction is idempotent)

  useEffect(() => {
    const path = window.location.pathname;
    getOneTeamData(path.toLowerCase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!currentTeam]);

  const getOneTeamData = async (path) => {
    try {
      const arr = path.split("/");
      const { data } = await authApi.post(
        `${TEAM_LIST}/${
          arr[arr.length - 1]
        }?search=${serachValue}&sortBy=${selectedValues1}`,
        {
          status: [],
        },
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      );
      setCurrentTeam(data);

      const newOnlineStatuses = {};
      data.team_members.forEach((member) => {
        const status = checkOnline(member.user_date?.[0]?._id);
        newOnlineStatuses[member._id] = status;
      });
      setCurrentTeamMembers(data.team_members);
      setOnlineStatuses(newOnlineStatuses);
    } catch (error) {
      // Intentionally ignored — not surfaced to the user
    }
  };

  const handleMenuclick = (event, item) => {
    event.stopPropagation();
    setEditMember(item);
    setOpenMenu(event.currentTarget);
  };

  const handleClick = (event, name) => {
    if (name === "ref1") {
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl1(event.currentTarget);
    }
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setOpenMenu(null);
    setAnchorEl(null);
    setAnchorEl1(null);
  };
  const handleMenuItemClick = async (event, name) => {
    event.stopPropagation();
    if (name === "edit") {
      setModleToggle(true);
      setTypeCall("edit");
    } else if (name === "delete") {
      if (editMember) {
        // Removing a member cascades server-side (drops them from
        // companies_registered, removes them from the team's chat group,
        // sends a "removed" SMS) — worth an explicit confirmation rather
        // than a single unconfirmed menu click.
        const confirmed = window.confirm(
          `Are you sure you want to remove ${editMember.user_name || "this member"} from the team?`
        );
        if (!confirmed) {
          handleClose(event);
          return;
        }

        try {
          // user_id used to be read off the client-supplied user_date
          // lookup and sent to the backend; the backend now resolves the
          // member to remove server-side from the team's own record and
          // never trusted this field, so it's no longer sent.
          const userEntry = { _id: editMember._id };
          await authApi.delete(
            `${TEAM_LIST}/${currentTeam._id}${DELETE_MEMBER}`,
            {
              headers: { Authorization: getAuthorizationHeader() },
              data: userEntry,
            },
          );
          getOneTeamData(window.location.pathname.toLowerCase());
        } catch (err) {
          setError(
            err.response?.data?.message || "Failed to remove member"
          );
          setShowAlert(true);
        }
      }
      //getData();
    }

    handleClose(event);
  };

  const hadleLogoutClick = async (event) => {
    try {
      event.stopPropagation();
      const member = teamMembersList.find(
        (member) => member.phone === editMember.mobile_number,
      );
      const topic = `App/${member.device_id}/message`;
      // eslint-disable-next-line unused-imports/no-unused-vars
      const status = await PublishMessage(
        topic,
        JSON.stringify({ forcelogout: 1 }),
      );
      // eslint-disable-next-line unused-imports/no-unused-vars
      const { data } = await authApi.put(
        `/users/force-logout/${editMember.mobile_number}`,
        {},
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      );
      getOneTeamData(window.location.pathname.toLowerCase());
      handleClose(event);
    } catch (error) {
      // Intentionally ignored — not surfaced to the user
    }
  };

  useEffect(() => {
    if (showAlert) {
      const timeout = setTimeout(() => {
        setShowAlert(false);
      }, 2000); // Change the duration (in milliseconds) as per your requirement

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showAlert]);

  const handleCardClick = async (event, id) => {
    // event.stopPropagation();
    try {
      await authApi.post(
        `${TEAM_MEMBER_DETAILS}/${id}`,
        {},
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      );
      const name = currentTeam.slug.toLowerCase();
      navigate(`/my-team/${name}/${id}`);
    } catch (error) {
      setShowAlert(true);
      setError(error.response.data.message || error.response.data.error);
    }
  };
  const CloseForm = (props) => {
    setModleToggle(props);
    setEditMember();
    setTypeCall();
    getOneTeamData(window.location.pathname.toLowerCase());
  };

  const CloseImportForm = (props) => {
    setImportModalToggle(props);
    getOneTeamData(window.location.pathname.toLowerCase());
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setAnchorEl1(null);
  };

  useEffect(() => {
    if (currentTeam) {
      dispatch(setHeaderName(currentTeam?.team_name));
      if (!currentTeamMembers || currentTeamMembers.length === 0) {
        setCurrentTeamMembers(currentTeam?.team_members);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTeam]);

  const clickClearAll = (name) => {
    if (name === "TimeFilter") {
      setSelectedValues1();
      dispatch(saveLocationTimeFilter());
    } else {
      setSelectedValues([]);
      dispatch(saveTeamMemberStatusFilter([]));
    }
  };

  const handleStatusCheckbox = async (value) => {
    const isSelected = selectedValues.includes(value);

    if (value === "all") {
      if (isSelected) {
        // Unselect all checkboxes
        setSelectedValues([]);
        dispatch(saveTeamMemberStatusFilter([]));
        setCurrentTeamMembers(currentTeam?.team_members);
      } else {
        // Select all checkboxes
        setSelectedValues([...TeamMemberStatus]);
        dispatch(saveTeamMemberStatusFilter([...TeamMemberStatus]));
        setCurrentTeamMembers(currentTeam?.team_members);
      }
    } else {
      // Toggle the selection of individual checkboxes
      let newSelectedValues = [];

      if (isSelected) {
        newSelectedValues = selectedValues.filter((v) => v !== value);
      } else {
        newSelectedValues = [...selectedValues, value];
      }
      let filtered;
      if (newSelectedValues.length > 0) {
        // eslint-disable-next-line array-callback-return
        filtered = await currentTeam?.team_members.filter((item) => {
          if (newSelectedValues.includes("online")) {
            if (checkOnline(item?.user_date?.[0]?._id) === "checkin") {
              return item;
            }
          }
          if (newSelectedValues.includes("offline")) {
            if (
              checkOnline(item?.user_date?.[0]?._id) === "checkout" ||
              checkOnline(item?.user_date?.[0]?._id) === undefined ||
              item?.user_date?.[0]?._id === undefined
            ) {
              return item;
            }
          }
        });
      } else {
        filtered = currentTeam?.team_members;
      }
      setCurrentTeamMembers(filtered);
      setSelectedValues(newSelectedValues);
      dispatch(saveTeamMemberStatusFilter([newSelectedValues]));

      const areAllSelected = TeamMemberStatus.filter(
        (item) => item !== "all",
      ).every((item) => newSelectedValues.includes(item));

      // Check the "All" checkbox if all others are selected
      if (areAllSelected) {
        setSelectedValues((prevSelected) => [...prevSelected, "all"]);
        dispatch(saveTeamMemberStatusFilter([...newSelectedValues, "all"]));
      } else {
        // Uncheck the "All" checkbox if any other checkbox is unselected
        setSelectedValues((prevSelected) =>
          prevSelected.filter((item) => item !== "all"),
        );
        dispatch(
          saveTeamMemberStatusFilter(
            newSelectedValues.filter((item) => item !== "all"),
          ),
        );
      }
    }
  };

  const handleAddMemberModal = () => {
    if (!currentTeam.customer_subscription) {
      setError("No active subscription found for this team");
      setShowAlert(true);
      return;
    }

    if (
      currentTeam.customer_subscription.end_date &&
      new Date(currentTeam.customer_subscription.end_date) < new Date()
    ) {
      setError("Team subscription has expired");
      setShowAlert(true);
      return;
    }

    if (
      currentTeam.team_members.length <
      currentTeam.customer_subscription.no_team_members
    ) {
      setModleToggle(true);
      setEditMember();
      setTypeCall("new");
    } else {
      setError(
        "You can add only " +
          currentTeam.customer_subscription.no_team_members +
          " members",
      );
      setShowAlert(true);
    }
  };

  const handleImportModal = () => {
    if (!currentTeam.customer_subscription) {
      setError("No active subscription found for this team");
      setShowAlert(true);
      return;
    }

    if (
      currentTeam.customer_subscription.end_date &&
      new Date(currentTeam.customer_subscription.end_date) < new Date()
    ) {
      setError("Team subscription has expired");
      setShowAlert(true);
      return;
    }

    if (
      currentTeam.team_members.length >=
      currentTeam.customer_subscription.no_team_members
    ) {
      setError(
        "You can add only " +
          currentTeam.customer_subscription.no_team_members +
          " members",
      );
      setShowAlert(true);
      return;
    }

    setImportModalToggle(true);
  };

  const handleTimeCheckBox = (value) => {
    setSelectedValues1(value);
    dispatch(saveLocationTimeFilter(value));
    const sortedMembersList = currentTeamMembers.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return selectedValues1?.includes("newest_to_oldest")
        ? dateA - dateB
        : dateB - dateA;
    });
    setCurrentTeamMembers(sortedMembersList);
  };
  const filterTeamMembers = (members, searchValue) => {
    return members.filter(
      (member) =>
        member.user_name.toLowerCase().includes(searchValue.toLowerCase()) ||
        member.mobile_number.toLowerCase().includes(searchValue.toLowerCase()),
      // regex.test( || member.name)
    ); // Assuming 'name' is the property to filter by
  };

  const filteredMembers = filterTeamMembers(
    currentTeamMembers || [],
    serachValue,
  );
  return (
    <div style={{ margin: "0 auto 0 15px" }}>
      {currentTeam && ln && (
        <>
          <Box sx={{ mb: 3 }} className={classes.brudCrumb}>
            <span onClick={() => navigate(-1)}>
              <BrudCrumbBackIcon />
            </span>
            <span onClick={() => navigate("/my-team")}>{ln.my_team}</span>
            <BrudCrumbNextIcon />
            <span style={{ color: "#6A6E8A" }}>
              {currentTeam ? currentTeam.team_name : ""}
            </span>
          </Box>
          <Card sx={{ p: 3 }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap", mb: 2 }}
            >
              <Typography className={classes.createTeamHeading} sx={{ mb: 0 }}>
                {currentTeam.team_name}
              </Typography>
              <GeofenceChip
                active={hasGeofence(currentTeam)}
                onClick={() =>
                  navigate(
                    `/my-team/${currentTeam.slug}/geofence${hasGeofence(currentTeam) ? "" : "/setup"}`
                  )
                }
              />
            </Box>
            <Typography
              className={classes.TeamPageMaindivSubHeding}
              sx={{ mb: 3, mt: 0 }}
            >
              <TotalMembersIcon />
              <span className={classes.teamPageHeading2}>
                {currentTeam && currentTeam.team_members
                  ? `${ln.total_members} ( ${currentTeam?.team_members?.length} )`
                  : null}
              </span>
            </Typography>
            {currentTeam?.customer_subscription &&
              (() => {
                const sub = currentTeam.customer_subscription;
                const isActive =
                  sub.payment_status === "completed" &&
                  (!sub.end_date || new Date(sub.end_date) > new Date());
                const memberCount = currentTeam.team_members?.length ?? 0;
                const memberLimit = sub.no_team_members ?? 0;
                const memberPct =
                  memberLimit > 0
                    ? Math.min((memberCount / memberLimit) * 100, 100)
                    : 0;
                const accentColor = isActive ? "#2e7d32" : "#c62828";
                const bgColor = isActive ? "#f1f8f1" : "#fdf3f3";

                return (
                  <Box
                    sx={{
                      mb: 3,
                      borderRadius: 2,
                      border: "1px solid",
                      borderColor: isActive ? "#c8e6c9" : "#ffcdd2",
                      borderLeft: `4px solid ${accentColor}`,
                      backgroundColor: bgColor,
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 2.5,
                        py: 1.5,
                        borderBottom: "1px solid",
                        borderColor: isActive ? "#c8e6c9" : "#ffcdd2",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {isActive ? (
                          <CheckCircleOutlineIcon
                            sx={{ color: accentColor, fontSize: 20 }}
                          />
                        ) : (
                          <ErrorOutlineIcon
                            sx={{ color: accentColor, fontSize: 20 }}
                          />
                        )}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: "#1a1a2e" }}
                        >
                          Subscription
                        </Typography>
                      </Box>
                      <Chip
                        label={isActive ? "Active" : "Expired"}
                        size="small"
                        sx={{
                          backgroundColor: isActive ? "#2e7d32" : "#c62828",
                          color: "#fff",
                          fontWeight: 600,
                          fontSize: "0.7rem",
                          height: 22,
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        px: 2.5,
                        py: 1.5,
                        display: "flex",
                        gap: 4,
                        flexWrap: "wrap",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <PeopleAltOutlinedIcon
                          sx={{ color: "#6A6E8A", fontSize: 18 }}
                        />
                        <Box>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#6A6E8A",
                              display: "block",
                              lineHeight: 1.2,
                            }}
                          >
                            Members
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: "#1a1a2e" }}
                          >
                            {memberCount} / {memberLimit}
                          </Typography>
                        </Box>
                      </Box>

                      {sub.end_date && (
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <EventOutlinedIcon
                            sx={{ color: "#6A6E8A", fontSize: 18 }}
                          />
                          <Box>
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#6A6E8A",
                                display: "block",
                                lineHeight: 1.2,
                              }}
                            >
                              {isActive ? "Expires" : "Expired"}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 600,
                                color: isActive ? "#1a1a2e" : accentColor,
                              }}
                            >
                              {new Date(sub.end_date).toLocaleDateString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )}
                            </Typography>
                          </Box>
                        </Box>
                      )}
                    </Box>

                    <Box sx={{ px: 2.5, pb: 1.5 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 0.5,
                        }}
                      >
                        <Typography variant="caption" sx={{ color: "#6A6E8A" }}>
                          Member usage
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#6A6E8A" }}>
                          {Math.round(memberPct)}%
                        </Typography>
                      </Box>
                      <LinearProgress
                        variant="determinate"
                        value={memberPct}
                        sx={{
                          height: 6,
                          borderRadius: 3,
                          backgroundColor: isActive ? "#c8e6c9" : "#ffcdd2",
                          "& .MuiLinearProgress-bar": {
                            backgroundColor:
                              memberPct >= 100 ? "#c62828" : accentColor,
                            borderRadius: 3,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                );
              })()}
            <div>
              <div
                className={classes.teamMembersmainDiv}
                style={{ height: "auto" }}
              >
                <div>
                  <div className="">
                    <TextField
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      placeholder="Search"
                      inputprops={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      className={classes.teamMemberSearch}
                      id="firstNameinput"
                      value={serachValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      size="small"
                    />
                  </div>
                </div>
                <div style={{ display: "flex", columnGap: 10 }}>
                  <div style={{ width: "auto" }}>
                    <Button
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      variant="outlined"
                      onClick={(e) => handleClick(e, "ref1")}
                      fullWidth
                      className={classes.filterbtns}
                    >
                      <div
                        className={classes.form_lable}
                        style={{ textTransform: "capitalize" }}
                      >
                        <FilterIcon /> {ln.all}
                      </div>
                      <div>
                        <ArrowDownIcon />
                      </div>
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <div className={classes.filterHeading}>
                        <Typography className={classes.filterHeader}>
                          {ln.filter}
                        </Typography>
                        <span
                          className={classes.claerBtn}
                          onClick={() => clickClearAll("statusfilter")}
                        >
                          {ln.clear_all}
                        </span>
                      </div>
                      <Divider />
                      {TeamMemberStatus.map((item, index) => {
                        return (
                          <MenuItem
                            key={index}
                            style={{
                              padding: "6px 25px 6px 0",
                              textTransform: "capitalize",
                            }}
                            onClick={() => handleStatusCheckbox(item)}
                          >
                            <Box sx={{ p: 1 }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedValues?.includes(item)}
                                    size="small"
                                  />
                                }
                                label={ln[item]?.replaceAll("_", " ")}
                              />
                            </Box>
                          </MenuItem>
                        );
                      })}
                    </Menu>
                  </div>
                  <div style={{ minWidth: "180px" }}>
                    <Button
                      id="basic-button1"
                      aria-controls={open1 ? "basic-menu1" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open1 ? "true" : undefined}
                      onClick={(e) => handleClick(e, "ref2")}
                      variant="outlined"
                      fullWidth
                      className={classes.filterbtns}
                    >
                      <div
                        className={classes.form_lable}
                        style={{
                          textTransform: "capitalize",
                          marginRight: "7px",
                        }}
                      >
                        <BiSortAlt2 /> {ln.newest_to_oldest}
                      </div>
                      <div>
                        <ArrowDownIcon />
                      </div>
                    </Button>
                    <Menu
                      anchorEl={anchorEl1}
                      open={Boolean(anchorEl1)}
                      onClose={handleMenuClose}
                    >
                      <div className={classes.filterHeading}>
                        <Typography className={classes.filterHeader}>
                          {ln.sort_by}
                        </Typography>
                        <span
                          className={classes.claerBtn}
                          onClick={() => clickClearAll("TimeFilter")}
                        >
                          {ln.clear_all}
                        </span>
                      </div>
                      <Divider />
                      {locationTimeFilter.map((item, index) => {
                        return (
                          <MenuItem
                            key={index}
                            style={{
                              padding: "6px 25px 6px 0",
                              textTransform: "capitalize",
                            }}
                            onClick={() => handleTimeCheckBox(item)}
                          >
                            <Box sx={{ p: 1 }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedValues1?.includes(item)}
                                    size="small"
                                  />
                                }
                                label={ln[item]?.replaceAll("_", " ")}
                              />
                            </Box>
                          </MenuItem>
                        );
                      })}
                    </Menu>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={classes.indexpageMainBtn}
              style={{
                marginBottom: "20px",
                marginTop: "20px",
                textAlign: "right",
                columnGap: "10px",
              }}
            >
              <Button
                variant="outlined"
                style={{ border: "2px solid #1976d2", color: "#1976d2" }}
                onClick={() => {
                  handleImportModal();
                }}
              >
                <FiUpload style={{ marginRight: "5px", color: "#1976d2" }} />
                Import from Excel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  handleAddMemberModal();
                }}
              >
                <IoAddCircleOutline style={{ marginRight: "5px" }} />
                {ln.add_member}
              </Button>
            </div>

            {currentTeamMembers && currentTeamMembers.length > 0 ? (
              <div
                className={`${classes.GridContainer} ${classes.TeamMemberGridcontaoiner}`}
              >
                {filteredMembers.length > 0 ? (
                  filteredMembers.map((item, index) => (
                    <TeamMemberCard
                      item={item}
                      key={index}
                      index={index}
                      handleCardClick={handleCardClick}
                      handleMenuclick={handleMenuclick}
                      openMenu={openMenu}
                      handleClose={handleClose}
                      handleMenuItemClick={handleMenuItemClick}
                      hadleLogoutClick={hadleLogoutClick}
                    />
                  ))
                ) : (
                  <p>No team players found</p>
                )}
              </div>
            ) : (
              <Typography variant="body1" sx={{ mt: 2 }}>
                No team members found
              </Typography>
            )}
          </Card>
        </>
      )}

      {modletoggle ? (
        <AddMemberModal
          modalClose={CloseForm}
          id={currentTeam._id}
          user={editMember}
          name={typecall}
        />
      ) : null}
      {importModalToggle ? (
        <ImportMembersModal modalClose={CloseImportForm} id={currentTeam._id} />
      ) : null}
      {showAlert && error && (
        <AlertBox type="error" message={error} stateName={setShowAlert} />
      )}
    </div>
  );
};

export default TeamViewPage;
